import * as React from 'react';
import Panel from './Panel';
import {LeaderboardEntry} from './AppTypes';

function LeaderboardRow({player}: {player: LeaderboardEntry}): JSX.Element {
    return (
        <tr>
            <td className="name">{player.name}</td>
            <td className="wins">{Number(player.winCount).toLocaleString()}</td>
            <td className="games">{Number(player.gameCount).toLocaleString()}</td>
        </tr>
    );
}

export function Leaderboard({topPlayers}: {topPlayers: LeaderboardEntry[]}): JSX.Element {
    return (
        <Panel id="leaderboard-panel">
            <p>Leaderboards</p>
            <table>
                <thead>
                    <tr>
                        <th className="name">Name</th>
                        <th className="wins"># Wins</th>
                        <th className="games"># Games</th>
                    </tr>
                </thead>
                <tbody>
                    {topPlayers.map((player, i) => (
                        <LeaderboardRow player={player} key={i} />
                    ))}
                </tbody>
            </table>
        </Panel>
    );
}



// WEBPACK FOOTER //
// ./src/Leaderboard.tsx